import React from 'react';

interface ButtonProps {
  onClick?: () => void;
  classes?: string;
  title?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export const Button: React.FC<ButtonProps> = ({ onClick, classes, disabled, title = 'Наступне запитання', type = 'button' }) => {
  return (
    <button type={type} className={`tda__btn ${classes || ''}`} onClick={onClick} disabled={disabled}>
      {title}
    </button>
  );
};
